/**
 * Wire-protocol version. Bump when `messages.ts` introduces a breaking change;
 * server rejects `hello` messages whose version does not match.
 */
export const PROTOCOL_VERSION = 1;
/**
 * Fixed simulation tick rate (Hz). 5 Hz = 200 ms per tick — snappy enough to
 * watch drones move, cheap enough to simulate a large factory on the server.
 */
export const TICK_HZ = 5;
export const TICK_MS = 1000 / TICK_HZ;
/**
 * Stored station-snapshot schema version. Bump whenever `Station`, `Machine`,
 * or `Drone` shape changes in a way old payloads need migrated. The migrator
 * in `apps/server/src/sim/snapshot.ts` reads `version` and walks legacy
 * payloads up to the current shape rather than wiping a save.
 *
 * v1 → v2 (Phase 17B): `{ station }` becomes `{ stations[], activeStationId }`.
 * v2 → v3 (Phase 17C): adds `crossStationContents` so the charter-wide
 *                       stockpile survives reloads. v2 payloads load with
 *                       an empty stockpile.
 */
export const STATION_SNAPSHOT_VERSION = 3;
/**
 * Hard cap on offline tick fast-forward. 8 hours at 5 Hz = 144 000 ticks.
 * Returning players never gain more than this, no matter how long they were
 * away — keeps the shared market predictable and rewards regular sessions.
 */
export const OFFLINE_CAP_TICKS = 8 * 60 * 60 * TICK_HZ;
/** Offline accrual runs at this fraction of live throughput (0.5 = half-rate). */
export const OFFLINE_RATE = 0.5;
//# sourceMappingURL=protocol.js.map